// extracted by mini-css-extract-plugin
export default {"arrow":"ProductImageGallery___ProductImageGallery-module__arrow___E3spd","blockClicks":"ProductImageGallery___ProductImageGallery-module__blockClicks___pGNb8"};